import checkedFetch from "./checkedFetch";

export default async function(url) {
  const { response } = await checkedFetch(url);
  const html = await response.text();
  return html;
}
